export const currencyOptions = {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  style: "currency",
  notation: "compact" as "compact" | "standard" | "scientific" | "engineering",
};
